import React from 'react'
import { Oval } from 'react-loader-spinner'

const Loading = ({ size = "" }) => {
    // console.log(size)
    return (
        <div class={`d-flex justify-content-center`}>
            <div class={`spinner-border ${size == "small" && "spinner-border-sm"}`} role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export default Loading

// export const LoadingGreen = () => {
//     return (
//         <>
//             <div
//                 className="d-flex justify-content-center h-100"
//             // style={{ height: "85vh", paddingTop: "15vh" }}
//             >
//                 <Oval
//                     height="50"
//                     width="50"
//                     color="#4fa94d"
//                     secondaryColor="#4fa94d"
//                 />
//             </div>
//         </>
//     )
// }